import React, { useContext, useCallback } from 'react';
import { Modal } from 'antd';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import AlertContext from '../context';

interface IProps {
  visible: boolean;
  alert: ManualAlert;
  onCancel: () => void;
}

const Confirmation = ({
  alert,
  visible,
  onCancel,
}: IProps) => {
  const { actions: { deleteAlerts } } = useContext(AlertContext);
  const onOk = useCallback(() => {
    deleteAlerts({
      variables: { alertIds: [alert.id] },
    });
    onCancel();
  }, [alert]);
  return (
    <Modal
      open={visible}
      destroyOnClose
      onCancel={onCancel}
      onOk={onOk}
      title="Delete Alert"
    >
      {
        `Are you sure that you want to delete the alert "${alert.name}"?
        This action cannot be reversed.
        `
      }
    </Modal>
  );
};

export default Confirmation;
